import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import task from '@/vuex/modules/task'
import authentication from '@/vuex/modules/authentication'
import friend from '@/vuex/modules/friend'
import group from '@/vuex/modules/group'
import workarea from '@/vuex/modules/workarea'
import filter from '@/vuex/modules/filter'
import favorites from '@/vuex/modules/favorites'
import organisations from '@/vuex/modules/organisations'

// Load Vuex into Vue
Vue.use(Vuex)

// Create the storage
export default new Vuex.Store({
    modules: {
        task,
        authentication,
        friend,
        group,
        workarea,
        filter,
        favorites,
        organisations
    },
    plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/vuex/store.js